module.exports = __webpack_public_path__ + "img/hm.fe514431.svg";